import { render, staticRenderFns } from "./SiteTreePanes.vue?vue&type=template&id=4d3d9a5c"
import script from "./SiteTreePanes.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteTreePanes.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports